export const enum MaxValue {
  MAX_SHORT_NAME = 30,
  MAX_LENGTH = 9,
  MAX_LONG_NAME = 75,
  MAX_INITIAL_VALUE = 255,
  MAX_DEFAULT_VALUE = 255,
}